import { client } from './client';

export const mapGetMarkers = () => client.get('/map');
